import { API_URL } from '../../../config'
import store from '../../store'

export default {
  namespaced: true,
  actions: {
    async getUsadoPorPosicion({}, payload) {
      const response = await fetch(`${API_URL}/exduenio/buscar`, {
        method: 'POST',
        headers: {
          'Content-Type': 'Application/json',
          Authorization: store.state.token
        },
        body: JSON.stringify(payload)
      })
      return response.json()
    },

    async editarPosicion({}, payload) {
      const response = await fetch(`${API_URL}/exduenio/editar`, {
        method: 'POST',
        headers: {
          'Content-Type': 'Application/json',
          Authorization: store.state.token
        },
        body: JSON.stringify(payload)
      })
      return response.json()
    },

    async getDireccionCliente({}, payload) {
      const response = await fetch(`${API_URL}/exduenio/direccion`, {
        method: 'POST',
        headers: {
          'Content-Type': 'Application/json',
          Authorization: store.state.token
        },
        body: JSON.stringify(payload)
      })
      return response.json()
    },


    async getUbicaciones({}, payload) {
      const response = await fetch(`${API_URL}/exduenio/ubicaciones`, {
        method: 'GET',
        headers: {
          'Content-Type': 'Application/json',
          Authorization: store.state.token
        }
      })
      return response.json()
    }
  }
}
